import { BUSINESS_UNITS } from '@/modules/bu/registry.base';

export function clearStoredSession(): void {
  if (typeof localStorage?.removeItem !== 'function') return;

  const retainedPrefixes = BUSINESS_UNITS.flatMap((bu) => bu.retainedStoragePrefixes ?? []);

  // Retain in-flight authorization and non-secret purchase deduplication markers.
  Object.keys(localStorage)
    .filter(
      (key) =>
        !retainedPrefixes.some((prefix) => key.startsWith(prefix)) &&
        !/^checkout-purchase:\d+:\d+$/.test(key),
    )
    .forEach((key) => localStorage.removeItem(key));
}
